import { player } from 'src/client/player';
import PauseCircleSolid from 'src/common/components/shared/svgIcons/player/PauseCircleSolid';
import PlayCircleSolid from 'src/common/components/shared/svgIcons/player/PlayCircleSolid';
import { playerStatuses } from 'src/common/constants/playerStatuses';
import { useStores } from 'src/common/providers';
import cssVariables from 'src/common/styles/variables';

const buttonSize = '36';

export default function VideoAdMediaButtons() {
  const { playerStore } = useStores();
  const playerStatus = playerStore.playerStatus();

  return (
    <div>
      {playerStatus === playerStatuses.paused ? (
        <PlayCircleSolid
          width={buttonSize}
          height={buttonSize}
          onClick={() => player.play()}
          fillButton={cssVariables['--black']}
          fillButtonBackground={cssVariables['--anti-flash-white']}
          doNotHover
        />
      ) : (
        <PauseCircleSolid
          width={buttonSize}
          height={buttonSize}
          onClick={() => player.pause()}
          fillButton={cssVariables['--black']}
          fillButtonBackground={cssVariables['--anti-flash-white']}
          doNotHover
        />
      )}
    </div>
  );
}
